import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Result, Button } from 'antd';
var SuccessfulPage = function () {
    var history = useHistory();
    var _a = useState(6), countdown = _a[0], setCountdown = _a[1];
    var _b = useState(countdown + "\u79D2\u540E\u81EA\u52A8\u8DF3\u8F6C\u81F3\u767B\u5F55\u9875"), subTitle = _b[0], setSubTitle = _b[1];
    useEffect(function () {
        var timer;
        if (countdown !== 0) {
            timer = window.setInterval(function () {
                var _countdown = countdown - 1;
                setCountdown(_countdown);
                setSubTitle(_countdown + "\u79D2\u540E\u81EA\u52A8\u8DF3\u8F6C\u81F3\u767B\u5F55\u9875");
            }, 1000);
        }
        // 跳转页面
        else if (countdown === 0) {
            history.replace('/login');
        }
        return function () { return window.clearInterval(timer); };
    }, [countdown, history]);
    return (React.createElement(Result, { status: "success", title: "\u5BC6\u7801\u91CD\u7F6E\u6210\u529F", subTitle: subTitle, extra: [
            React.createElement(Button, { type: "primary", key: "primary", block: true, onClick: function () { return history.replace('/login'); } }, "\u7ACB\u5373\u524D\u5F80"),
        ] }));
};
export default React.memo(SuccessfulPage);
